import { render } from "./IPFormGroup.vue?vue&type=template&id=3c8bc370"
import script from "./IPFormGroup.vue?vue&type=script&lang=js"
export * from "./IPFormGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__